/* global gsap */
// import {ScrollTrigger} from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);

export default class Animates {
	constructor(gsapElements) {
		if ( ! gsapElements ) return;
		gsap.set(".gsap-animation", { });
		this.gsapElements = gsap.utils.toArray('.gsap-animation');
		this.gsapOptions = {
			"right-to-left":
				{
					"closest": ".gsap-closest",
					"scrub": 3,
					"start": "top bottom",
					"end": ".25",
					"from": {"xPercent":50,"opacity": 0},
					"to": {"xPercent": 0,"opacity": 1,"duration": 1}
				},
			"left-to-right":
				{
					"closest": ".gsap-closest",
					"scrub": 3,
					"start": "top bottom",
					"end": ".25",
					"from": {"xPercent":-50,"opacity": 0},
					"to": {"xPercent": 0,"opacity": 1,"duration": 1}
				},
		}

		this.init();
	}

	init() {
		this.gsapElements.forEach((el, i) => {
			let dataGSAP = el.dataset.gsap
			if (this.gsapOptions.hasOwnProperty(dataGSAP)) {
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: el.closest(this.gsapOptions[dataGSAP].closest),
						start: () => this.gsapOptions[dataGSAP].start,
						end: () => "+=" + window.innerHeight * this.gsapOptions[dataGSAP].end,
						scrub: this.gsapOptions[dataGSAP].scrub,
						pin: false,
						invalidateOnRefresh: true,
					}
				}).fromTo(el, this.gsapOptions[dataGSAP].from, this.gsapOptions[dataGSAP].to, "-=0.2")
			}
			else if (dataGSAP ==='parallax-background') {
				gsap.to(".gsap-animation",  {
					backgroundPosition: `50% ${-innerHeight / 3}px`,
					ease: "none",
					scrollTrigger: {
						trigger: el.closest('.gsap-closest'),
						scrub: true
					},
				});
			}
		});
	}
}
